export function goToBookingTop() {
    window.location.replace('/bookings/new/');
}

export function consoleLogout() {
    window.location.assign('/console/logout/');
}
